import {groups} from '@becollective/constants';

export default groups.groupTypes;

export const INDUSTRY_WITH_TYPES = ['business'];
